import type { Plugin } from "@flare/analytics";

import { isBrowser } from "@/utils/isBrowser";

function getUserType() {
  if (!isBrowser()) {
    return null;
  }

  if (window.location.pathname.startsWith("/co-counsels")) {
    return "co-counsel";
  }

  return "pre-client";
}

/**
 * Plugin to identify the user based on the current URL.
 *
 */
export const indentifyUser = {
  name: "Indentify user plugin",
  type: "enrichment",
  version: "1.0.0",

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: (ctx) => {
    const currentEventProperties = ctx.event.properties || {};

    if ("userType" in currentEventProperties) {
      return ctx;
    }

    const userType = getUserType();

    ctx.updateEvent("properties", {
      ...currentEventProperties,
      userType,
    });

    return ctx;
  },
} satisfies Plugin;
